import style from '../style/Analysis.module.less';
import { RouteObjectWithMeta } from '@/pages/front/pages/examCenter/pages/analysis/router';
import { NavLink, useLocation } from 'react-router-dom';
import IconFont from '@/common/IconFont';

interface AnalysisProps {
  routes: RouteObjectWithMeta[];
}
const AnalysisMenu: React.FC<AnalysisProps> = props => {
  const location = useLocation();

  return (
    <div className={style.menu} data-class="menu">
      {
        props.routes.map(i => <NavLink key={i.path} to={i.path + location.search}>
          <IconFont type={i.icon ||''} className={style.anticon}/>
          <span>{i.name}</span>
        </NavLink>)
      }
    </div>
  );
};

export default AnalysisMenu;
